





















import { ElTable } from "element-ui/types/table";
import { Mixins, Component, Prop, Watch, Emit } from "vue-property-decorator";
import { ILinkedPageObjectSpecifiable } from "../../../../../../../documaker/domain/format/objects";

export type FormatObjectSelectorColumnTypes =
  "selection" |
  "index" |
  "type" |
  "id" |
  "key" |
  "subKey" |
  "pageNumber";

@Component
export default class FormatObjectSelector extends Mixins() {
  @Prop({ default: () => [] as FormatObjectSelectorColumnTypes[] })
  columns: FormatObjectSelectorColumnTypes[];

  @Prop({ default: () => [] as ILinkedPageObjectSpecifiable[] })
  items: ILinkedPageObjectSpecifiable[];

  @Prop({ type: Function, default: () => "" })
  toCellString: (column: FormatObjectSelectorColumnTypes, row: ILinkedPageObjectSpecifiable) => string;

  tableData: ILinkedPageObjectSpecifiable[] = [];

  $refs!: {
    table: ElTable,
  };

  get isSingleSelect(): boolean {
    return !this.columns.some(c => c === "selection");
  }

  mounted() {
    this.tableData = this.items;
  }

  toColumnAttribute(column: FormatObjectSelectorColumnTypes) {
    switch (column) {
      case "selection":
        return { type: column, width: "55" };
      case "index":
        return { type: column, index: (i: number) => i + 1, label: "項番", width: "55" };
      case "type":
        return { label: "オブジェクト名", width: "155" };
      case "id":
        return { label: "ID", width: "70" };
      case "key":
        return { label: "名称" };
      case "subKey":
        return { label: "分類" };
      case "pageNumber":
        return { label: "ページ", width: "70" };
      default:
        return null;
    }
  }

  clearSelection() {
    this.$refs.table.clearSelection();
  }

  toggleRowSelection(indexes: number[], selected?: boolean) {
    indexes.forEach(i => this.$refs.table.toggleRowSelection(this.items[i], selected));
  }

  toggleAllSelection() {
    this.$refs.table.toggleAllSelection();
  }

  setCurrentRow(index?: number) {
    if (typeof index === "number") {
      this.$refs.table.setCurrentRow(this.items[index]);
    } else {
      // 本来であればsetCurrentRow()を引数なしで呼べはリセットされるはずだが、2.11.1では動作しない。代替としてdataの入れ直しで対応する
      this.tableData = [];
      this.$nextTick(() => this.tableData = this.items);
    }
  }

  @Watch("columns")
  onColumnsUpdated(newValue: FormatObjectSelectorColumnTypes[], oldValue: FormatObjectSelectorColumnTypes[]) {
    this.doLayout();
  }

  @Watch("items")
  onItemsUpdated(newValue: ILinkedPageObjectSpecifiable[], oldValue: ILinkedPageObjectSpecifiable[]) {
    this.tableData = newValue;
    this.doLayout();
  }

  private doLayout() {
    // element-uiのテーブルにスクロールバーが表示される際、ヘッダがずれる問題に対応するため、dataプロパティ更新時に遅延でdoLayoutを呼び出す
    this.$nextTick(() => this.$doWhenValid(t => t.doLayout(), this.$refs.table));
  }

  @Emit()
  selectionChange(selection: ILinkedPageObjectSpecifiable[]): void {}

  @Emit()
  currentChange(currentRow: ILinkedPageObjectSpecifiable, oldCurrentRow: ILinkedPageObjectSpecifiable): void {}
}
